import ThankButton from "@/components/ThankButton";
import TipButton from "@/components/TipButton";
import AuthorMenu from "@/components/AuthorMenu";

// Map the thank/reply context to a flag target so the author menu's Report
// option tags exactly where it was flagged (post / reply / listing).
const REPORT_TARGET = { post: "post", comment: "reply", event: "event", team: "team", trainer_listing: "trainer_listing" };

/**
 * Author actions shown next to a username: Thank (handshake) + optional Tip + a
 * chevron-down menu (Follow / Message / Report). Tip only renders when the author
 * has tip links enabled.
 */
export default function AuthorThankTip({ userId, username, tipLinks, thanksCount = 0, contextType, contextId }) {
    if (!userId) return null;
    const reportType = REPORT_TARGET[contextType] || null;
    return (
        <span className="inline-flex items-center gap-1.5" data-testid="author-thank-tip">
            <ThankButton toUser={userId} toName={username} contextType={contextType} contextId={contextId} initialCount={thanksCount} />
            <TipButton tipLinks={tipLinks} name={username} />
            <AuthorMenu userId={userId} name={username} reportType={reportType} reportId={reportType ? contextId : null} />
        </span>
    );
}
